import type { TFunction } from 'i18next';

import { EntityType, type Hcphco } from '@/core/graphql/generated/types';

import type { NameFieldDef } from './nameEditFormSchema';

export const NAME_GROUP_KEY = '__name__';

export const getNameFieldDefs = (
	entityType: EntityType,
	t: TFunction
): NameFieldDef[] =>
	entityType === EntityType.Hcp
		? [
				{ name: 'firstNameCda_V', label: t('First Name'), required: true },
				{ name: 'middleNameCda_V', label: t('Middle Name'), required: false },
				{ name: 'lastNameCda_V', label: t('Last Name'), required: true }
			]
		: [{ name: 'hcoNameCda_V', label: t('Name'), required: true }];

export const getNameValues = (
	profile: Hcphco
): Record<string, string | null | undefined> => {
	if (profile.__typename === 'HCP') {
		return {
			firstNameCda_V: profile.firstNameCda_V,
			middleNameCda_V: profile.middleNameCda_V,
			lastNameCda_V: profile.lastNameCda_V
		};
	}

	if (profile.__typename === 'HCO') {
		return { hcoNameCda_V: profile.hcoNameCda_V };
	}

	return {};
};
